import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
	XThemeModal,
	XThemeSelect,
	XAffix,
	XContainer,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
	Modal,
	Tooltip,
	Upload,
	Skeleton,
	Tag,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVACheckbox,
	XThemeVASubmitBTN,
	XVSLottie,
	XVSLottieWrapper,
	XThemeVSCollapse,
	XThemeVSDetailsCard,
	XThemeHeaderBTN,
	XThemeVSDetailsFooter,
	XThemeVoiceAssCard2,
	XThemeVoiceAssContainer,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSSumInnerCard,
	XThemeVSSumListCard,
	XThemeVAViewHiddenBTN,
} from '../../VoiceAssistanceStyle';
import {
	CalendarOutlined,
	CaretRightOutlined,
	PlusCircleOutlined,
	PlusSquareOutlined,
	RightOutlined,
	WarningOutlined,
	DeleteOutlined,
	EditOutlined,
	InboxOutlined,
	CloseOutlined,
	ArrowLeftOutlined,
} from '@ant-design/icons';
import VSLoaderJson from '../../../../json/loader.json';
import VSdotsAnimation from '../../../../json/dotsAnimation.json';
import { Editor } from '@tinymce/tinymce-react';
import config from '../../../../config';
import dayjs from 'dayjs';
import { getUserToken, toTitleCase } from '../../../../utils/helper';
import axios from 'axios';
import { handleInputChange } from '../../../../utils/formFunctions';
import {
	XButtonCloseBar,
	XButtonReload,
	XNotificationBar,
} from '../../../AnalyseCoverage/AnalyseCoverageStyle';

const { TextArea } = Input;
const { Dragger } = Upload;

const VACaseDetails = (props) => {
	const {
		patientData,
		mainDataLoading,
		handleClinicalDocsChange = () => {},
		clinicalDocumentFileList,
		clinicalDocsForm,
		clinicalDocsLoading,
		handleUploadCancel = () => {},
		setIsClinicalUploadModalOpen,
		isClinicalUploadModalOpen,
		setPreviewImage,
		previewImage,
		setPreviewTitle,
		previewTitle,
		setPdfPreviewOpen,
		pdfPreviewOpen,
		documentsToDisplay,
		clinicalSummaryTextLoading,
		setClinicalSummaryTextLoading,
		showClinicalTextArea,
		setShowClinicalTextArea,
		id,
		editCase = () => {},
		handleRemoveClinicalDocuments = () => {},
		setPageContent,
		pageContent,
		clinicalDocumentsToDisplay,
		feedbackId,
		reviseCoverage,
		reviseCoverageReset,
		lastAnalysisData,
		setLoading,
		loading,
		getBase64 = () => {},
		setClinicalDocsLoading,
		setSubmitClinicalDocs,
		setUpdatedClinicalDocumentFileList,
		form,
		setModalTextArea,
		setModalOpen,
		handleCodeClick = () => {},
		handleClinicalSummaryDoc = () => {},
		modalOpen,
		sendFeedback,
		sendFeedbackState,
		modalTextArea,
		updatePageContent,
		missingFieldsForm,
		missingFieldsCardRef,
		handleAddOption,
		missingFields,
		missingFieldInstructions,
		setMissingFieldsModal,
		setMissingFieldInstructions,
		setMissingFields,
		missingFieldTitle,
		missingFieldsModal,
		isOpenAnalysis,
		supportingDocsSummary,
		summary,
		setSummary,
		provider,
		state,
		dateOfBirth = () => {},
		matchGender,
		previewMode,
		aipa,
		currentRevision,
		checkCoverage,
		clinicalAudioToDisplay,
		isClinicalUploadAudioModalOpen,
		setIsClinicalUploadAudioModalOpen,
		audioBlob,
		recordingTime,
		isRecording,
		isPlaying,
		audioElementRef,
		isPaused,
		handleStop,
		handleResume,
		handlePause,
		handleDone,
		toggleDictation,
		handlePausePlayback,
		handlePlayRecording,
		handleRemoveClinicalAudios = () => {},
		handleUploadAudioCancel = () => {},
		handleClinicalSummaryAudio = () => {},
		audioPlayModal,
		setAudioPlayModal,
		fileToPlay,
		setFileToPlay,
		handlePlayRecordedNote,
		clinicalAudioForm,
		setRecordingTime,

		analysisData,
		onSendFeedback,
		onReanalyze,
		setCoverageLoading,
		coverageloading,
		setLooksGoodLoading,
		LooksGoodLoading,
		openedFromTable = false,
		onBackToTable = () => {},
		previousActionParameters = null,
		setClinicalDocumentsToDisplay,
	} = props;

	// States
	const [isCollapsedScroll, setIsCollapsedScroll] = useState(true);
	const [clinicalForm] = XThemeForm.useForm();
	const [previewOpen, setPreviewOpen] = useState(false);
	const [coverage, setCoverage] = useState('Yes');
	const [formData, setFormData] = useState();
	const [isExpanded, setIsExpanded] = useState(false);
	const [expandedStates, setExpandedStates] = useState([]);
	const [mainExpanded, setMainExpanded] = useState(false);
	const contentRefs = useRef([]);
	const mainContentRef = useRef(null);
	const editorRef = useRef(null);
	const [editorContent, setEditorContent] = useState('');
	// Add to your existing refs
	const clinicalSummaryRef = useRef(null);
	const [clinicalExpanded, setClinicalExpanded] = useState(false);
	const [shouldShowReadMore, setShouldShowReadMore] = useState(false);
	const [activeCollapseKey, setActiveCollapseKey] = useState('1');
	const [contentRendered, setContentRendered] = useState(false);

	// Handle back button click
	const handleBackToTable = () => {
		console.log('=== VACaseDetails handleBackToTable Debug ===');
		console.log('openedFromTable:', openedFromTable);
		console.log('onBackToTable:', onBackToTable);
		console.log('previousActionParameters:', previousActionParameters);
		
		if (openedFromTable && onBackToTable) {
			let backAction = 'table_list';
			let backComponent = 'data_table_list';

			console.log('previousActionParameters.original_action:', previousActionParameters?.original_action);
			console.log('previousActionParameters.batch_id:', previousActionParameters?.batch_id);

			// Check for original_action first
			if (previousActionParameters && previousActionParameters.original_action) {
				if (previousActionParameters.original_action === 'batch_details') {
					backAction = 'batch_details';
					backComponent = 'batches';
					console.log('Setting backAction to batch_details based on original_action');
				} else if (previousActionParameters.original_action === 'table_list') {
					backAction = 'table_list';
					backComponent = 'data_table_list';
					console.log('Setting backAction to table_list based on original_action');
				}
			}
			// Fallback to batch_id check for backward compatibility
			else if (previousActionParameters && previousActionParameters.batch_id) {
				backAction = 'batch_details';
				backComponent = 'batches';
				console.log('Setting backAction to batch_details based on batch_id fallback');
			}

			console.log('Final backAction:', backAction);
			console.log('Final backComponent:', backComponent);

			// Create parameters object for batch_details action
			let parameters = { ...previousActionParameters };
			
			// For batch_details action, ensure we have 'id' parameter instead of 'batch_id'
			if (backAction === 'batch_details' && previousActionParameters?.batch_id) {
				parameters.id = previousActionParameters.batch_id;
				delete parameters.batch_id; // Remove batch_id to avoid confusion
				console.log('Converting batch_id to id for batch_details action:', parameters.id);
			}

			onBackToTable({
				response_type: 'action',
				action: backAction,
				component: backComponent,
				parameters: parameters,
			});
		}
	};

	// Add this useEffect
	useEffect(() => {
		if (documentsToDisplay?.length) {
			setExpandedStates(new Array(documentsToDisplay.length).fill(false));
		}
	}, [documentsToDisplay]);

	useEffect(() => {
		return () => {
			if (editorRef.current) {
				editorRef.current = null;
			}
			setEditorContent('');
			clinicalForm.resetFields();
		};
	}, []);

	const handleClinicalDocsUpload = async () => {
		try {
			if (isOpenAnalysis) {
				await clinicalDocsForm.validateFields(['clinical_docs']); // Await validation
				setClinicalDocsLoading(true);
				handleClinicalSummaryDoc();
			} else {
				clinicalDocsForm
					.validateFields()
					.then(async () => {
						if (clinicalDocumentFileList.length > 0) {
							setClinicalDocsLoading(true);
							await Promise.all(
								clinicalDocumentFileList.map(
									async (fileData) => {
										let get_ext =
											fileData.originFileObj.name.split(
												'.',
											);
										let ext = get_ext[get_ext.length - 1];
										const res = await axios.get(
											// `${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=original_documents&file_name=denial_letter&ext=pdf&id=denial_letter`,
											`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=clinical_documents&file_name=${patientData.patient_last_name}${fileData.originFileObj.uid}&ext=${ext}&id=${patientData.case_id}`,
											{
												headers: {
													'Content-type':
														'application/json; charset=UTF-8',
													Authorization:
														'Bearer ' +
														getUserToken(),
												},
											},
										);

										const result = await axios.put(
											res.data.data,
											fileData.originFileObj,
										);

										if (result.status === 200) {
											// const documentPath = `/original_documents/denial_letter/denial_letter.pdf`;
											const documentPath = `/clinical_documents/${patientData.case_id}/${patientData.patient_last_name}${fileData.originFileObj.uid}.${ext}`;
											const newFile = {
												uid: fileData.originFileObj.uid,
												name: fileData.originFileObj
													.name,
												status: 'done',
												url: documentPath,
											};
											setUpdatedClinicalDocumentFileList(
												(prevFileList) => [
													{ url: newFile },
												],
											);
										}
									},
								),
							).then((res) => {
								setSubmitClinicalDocs(true);
							});
						}
						setSubmitClinicalDocs(true);
					})
					.catch((err) => {
						setClinicalDocsLoading(false);
					});
			}
		} catch (error) {
			setSubmitClinicalDocs(false);
			// Handle error if any
			// notification.success({
			// 	message: 'Could not upload',
			// });
			setClinicalDocsLoading(false);
			console.error('Error occurred:', error);
		}
	};

	const capitalizeFirstLetter = (string) => {
		if (!string) return string; // Return the string if it's null or undefined
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	//Clinical Docs Upload
	const showClinicalModal = () => {
		setIsClinicalUploadModalOpen(true);
	};

	const handlePreview = async (file) => {
		if (
			file &&
			file.name &&
			file.url &&
			file.name.split('.').includes('pdf')
		) {
			setPreviewImage(`${config.s3_url}${file.url}` || file.preview);
			setPdfPreviewOpen(true);
		} else {
			if (
				!file.url &&
				!file.preview &&
				file.name.split('.').includes('pdf')
			) {
				file.preview = await getBase64(file.originFileObj);
			}

			setPreviewImage(file.preview);
			setPdfPreviewOpen(true);
			setPreviewTitle(
				file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
			);
		}
	};

	const showClinicalDelete = (title, file) => {
		XThemeModal.confirm({
			title: `Delete ${title}?`,
			content: (
				<p className="modalPara1">
					Are you sure you want to delete - {title}?
				</p>
			),
			icon: (
				<span className="modalTitleIcon">
					<img src="/images/delete-modal-icon.svg" alt="delete" />
				</span>
			),
			okText: 'Yes, Confirm',
			okType: 'danger',
			cancelButtonProps: {
				className: 'xThemeCancelSubmit',
			},
			okButtonProps: {
				className: 'xThemeButtonSubmit',
			},
			cancelText: 'No, Cancel',
			// className: 'confirmModal',
			onOk: async () => {
				// Make an API call to delete the file from S3 and your collection
				try {
					// Extract file name and extension from the file URL
					const urlParts = file.url.split('/');
					const fileName = urlParts[urlParts.length - 1];
					const case_id = urlParts[urlParts.length - 2];
					const [patientName, ext] = fileName.split('.');

					// Make API calls to delete the file from S3 and collection
					await axios.delete(
						`${config.api.base_url}/settings/delete-signed-url?folder_name=clinical_documents&file_name=${patientName}&ext=${ext}&id=${case_id}`,
						{
							headers: {
								Authorization: 'Bearer ' + getUserToken(),
							},
						},
					);

					// Remove the file from supporting_docs array
					const updatedClinicalDocs =
						clinicalDocumentsToDisplay.filter(
							(item) => item.url.uid === file.uid,
						);

					// Make API call to update the supporting_docs field in your case
					await editCase({
						id: id,
						deleted_clinical_docs: updatedClinicalDocs,
						remove: true,
						singleDelete: true,
					});

					console.log(
						'File deleted successfully from S3 and collection',
					);
				} catch (error) {
					console.error('Error deleting file:', error);
					// Handle error
				}
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};

	const deletePageContent = (item, id) => {
		const updatedPageContent = { ...pageContent };
		updatedPageContent[[item]].splice(id, 1);
		setPageContent(updatedPageContent);
		setModalOpen([false, '', ' ']);
		setModalTextArea('');
		form.resetFields();
		document.getElementById('notification')?.classList.remove('d-none');
	};

	const showDeleteConfirm = (title, id, content, item) => {
		XThemeModal.confirm({
			title: `Delete ${title}?`,
			content: (
				<p className="modalPara1">
					Are you sure you want to delete - {content}?
				</p>
			),
			icon: (
				<span className="modalTitleIcon">
					<img src="/images/delete-modal-icon.svg" alt="delete" />
				</span>
			),
			okText: 'Yes, Confirm',
			okType: 'danger',
			cancelText: 'No, Cancel',
			// className: 'confirmModal',
			cancelButtonProps: {
				className: 'xThemeCancelSubmit',
			},
			okButtonProps: {
				className: 'xThemeButtonSubmit',
			},
			onOk() {
				deletePageContent(item, id);
			},
			onCancel() {
				console.log('Cancel');
			},
		});
	};

	// Add this useEffect to measure clinical summary height and update the state
	useEffect(() => {
		// Function to check content height and update read more button visibility
		const checkContentHeight = () => {
			if (clinicalSummaryRef.current) {
				const isOverflowing =
					clinicalSummaryRef.current.scrollHeight > 200;
				setShouldShowReadMore(isOverflowing);

				// If we've confirmed the content is rendered properly, mark it
				if (clinicalSummaryRef.current.scrollHeight > 0) {
					setContentRendered(true);
				}
			}
		};

		// Run the check immediately
		checkContentHeight();

		// Set up multiple checks to handle different rendering scenarios
		const timer1 = setTimeout(checkContentHeight, 100);
		const timer2 = setTimeout(checkContentHeight, 500);
		const timer3 = setTimeout(checkContentHeight, 1000);

		// Create a ResizeObserver to detect any size changes in the container
		if (clinicalSummaryRef.current) {
			const resizeObserver = new ResizeObserver(() => {
				checkContentHeight();
			});

			resizeObserver.observe(clinicalSummaryRef.current);

			return () => {
				clearTimeout(timer1);
				clearTimeout(timer2);
				clearTimeout(timer3);
				resizeObserver.disconnect();
			};
		}

		return () => {
			clearTimeout(timer1);
			clearTimeout(timer2);
			clearTimeout(timer3);
		};
	}, [
		pageContent?.clinical_summary,
		patientData?.clinical_summary,
		showClinicalTextArea,
		activeCollapseKey,
		contentRendered,
	]);

	// Add this function for code editing modal
	const handleModalEdit = (row, index, type) => {
		// For items with codes, extract the description and code separately
		if (type === 'pastHistory' || type === 'presentComplaint') {
			const splitItem = row.split('- ICD-10 Code:');
			if (splitItem.length > 1) {
				form.setFieldsValue({
					modal_text_area: splitItem[0].trim(),
					code: splitItem[1].trim(),
				});
			} else {
				form.setFieldsValue({
					modal_text_area: row,
					code: '',
				});
			}
		} else if (type === 'recommendedProcedure') {
			const splitItem = row.split('- CPT Code:');
			if (splitItem.length > 1) {
				form.setFieldsValue({
					modal_text_area: splitItem[0].trim(),
					code: splitItem[1].trim(),
				});
			} else {
				form.setFieldsValue({
					modal_text_area: row,
					code: '',
				});
			}
		} else {
			form.setFieldsValue({
				modal_text_area: row,
			});
		}

		setModalTextArea(row);
		setModalOpen([
			true,
			`Edit ${
				type === 'pastHistory'
					? 'Past Clinical History'
					: type === 'presentComplaint'
					? 'Present Complaint'
					: 'Denial Procedure'
			}`,
			row,
			index,
			type,
		]);
	};

	// Generate the collapse items for the different sections
	const getCollapseItems = () => {
		return [
			{
				key: '1',
				label: 'Clinical Summary',
				children: (
					<XThemeVSSumInnerCard>
						<Row>
							<Col xs={24} className="text-end headerBorder">
								<Space>
									{!showClinicalTextArea && !previewMode && (
										<XThemeVASubmitBTN
											size="medium"
											className="radiusBtn"
											shape="square"
											icon={
												<img
													src="/images/edit-icon.svg"
													alt=""
												/>
											}
											onClick={() => {
												setShowClinicalTextArea(true);
												clinicalForm.setFieldsValue({
													clinical_summary:
														isOpenAnalysis
															? summary
															: patientData.clinical_summary,
												});
											}}
										/>
									)}
									{clinicalDocumentsToDisplay &&
										clinicalDocumentsToDisplay.length >
											0 && (
											<>
												{clinicalDocumentsToDisplay.map(
													(ele, idx) => (
														<>
															<Tooltip
																title={
																	ele.document_name ||
																	ele.name ||
																	ele.url
																		?.name
																}
																placement="top"
															>
																<XThemeVASubmitBTN
																	size="medium"
																	className="radiusBtn"
																	shape="square"
																	icon={
																		<img
																			src="/images/pdf-new-icon.svg"
																			style={{
																				width: '20px',
																			}}
																			alt="pdf"
																		/>
																	}
																	onClick={() =>
																		isOpenAnalysis
																			? handlePreview(
																					ele,
																			  )
																			: handlePreview(
																					ele.url,
																			  )
																	}
																/>
															</Tooltip>

															<XThemeVASubmitBTN
																size="medium"
																className="radiusBtn"
																shape="square"
																icon={
																	<DeleteOutlined />
																}
																onClick={() => {
																	isOpenAnalysis
																		? handleRemoveClinicalDocuments(
																				ele,
																		  )
																		: showClinicalDelete(
																				'Clinical Summary Document',
																				ele.url,
																		  );
																}}
															/>
														</>
													),
												)}
											</>
										)}
									{(!clinicalDocumentsToDisplay ||
										clinicalDocumentsToDisplay.length ===
											0) && (
										<XThemeVASubmitBTN
											size="medium"
											className="radiusBtn"
											shape="square"
											icon={<PlusSquareOutlined />}
											onClick={() => {
												showClinicalModal();
											}}
										/>
									)}
								</Space>
							</Col>
						</Row>

						<Row gutter={[15, 15]}>
							<Col xs={24}>
								{!showClinicalTextArea ? (
									<Col xs={24} lg={24}>
										<>
											<div className="para text-justify">
												<div
													className={`content-wrapper ${
														clinicalExpanded
															? 'expanded'
															: ''
													}`}
													style={{
														maxHeight:
															clinicalExpanded
																? 'none'
																: '200px',
														overflow: 'hidden',
														position: 'relative',
													}}
												>
													<div
														ref={clinicalSummaryRef}
														dangerouslySetInnerHTML={{
															__html:
																pageContent?.clinical_summary ||
																patientData?.clinical_summary,
														}}
													/>
													{!clinicalExpanded &&
														shouldShowReadMore && (
															<div
																style={{
																	position:
																		'absolute',
																	bottom: 0,
																	left: 0,
																	right: 0,
																	height: '50px',
																	background:
																		'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))',
																}}
															/>
														)}
												</div>
												{shouldShowReadMore && (
													<div
														onClick={() =>
															setClinicalExpanded(
																!clinicalExpanded,
															)
														}
														style={{
															color: '#007299',
															cursor: 'pointer',
															marginTop: '15px',
															float: 'right',
														}}
													>
														{clinicalExpanded
															? 'Read Less'
															: 'Read More'}
													</div>
												)}
											</div>
										</>
									</Col>
								) : (
									<Form
										form={clinicalForm}
										onFinish={(values) => {
											const content = editorRef.current
												? editorRef.current.getContent()
												: '';
											setClinicalSummaryTextLoading(true);
											if (isOpenAnalysis) {
												updatePageContent(
													'originalQuery',
													null,
													content,
												);
											} else {
												editCase({
													id,
													...values,
													clinical_summary: content,
												});
											}
										}}
										className="w-100"
									>
										<Col xs={24} className="text-end">
											<Form.Item
												name="clinical_summary"
												className="drawerlabel mb-0"
												rules={[
													{
														required: true,
														message:
															'Please enter clinical summary',
													},
												]}
											>
												<Editor
													apiKey={config.tiny_url_key}
													onInit={(evt, editor) => {
														editorRef.current =
															editor;
														const initialContent =
															pageContent?.clinical_summary ||
															patientData?.clinical_summary;
														if (initialContent) {
															editor.setContent(
																initialContent,
															);
														}
													}}
													init={{
														menubar: false,
														plugins: [
															'code',
															'image',
															'link',
															'visualblocks',
														],
														branding: false,
														toolbar:
															'undo redo | formatselect | ' +
															'bold italic backcolor | alignleft aligncenter alignright alignjustify | blocks fontfamily fontsize | ' +
															'bullist numlist outdent indent | image link |' +
															'removeformat | visualblocks code | help ',
														content_style:
															'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
														font_size_formats:
															'8px 10px 12px 14px 18px 24px 36px',
														forced_root_block: 'p',
														entity_encoding: 'raw',
														height: 300,
														setup: function (
															editor,
														) {
															editor.on(
																'BeforeSetContent',
																function (e) {
																	if (
																		e.content ===
																			null ||
																		e.content ===
																			undefined
																	) {
																		e.content =
																			'';
																	}
																},
															);
														},
													}}
													onEditorChange={(
														content,
														editor,
													) => {
														setEditorContent(
															content,
														);
														if (isOpenAnalysis) {
															setSummary(content);
														}
														clinicalForm.setFieldsValue(
															{
																clinical_summary:
																	content,
															},
														);
														if (handleInputChange) {
															handleInputChange(
																{
																	target: {
																		name: 'clinical_summary',
																		value: content,
																	},
																},
																formData,
																setFormData,
															);
														}
													}}
												/>
											</Form.Item>
										</Col>
										<Col xs={24} className="text-end mt-2">
											<XThemeVASubmitBTN
												size="medium"
												className="me-3"
												onClick={() => {
													setShowClinicalTextArea(
														false,
													);
												}}
											>
												Cancel
											</XThemeVASubmitBTN>
											<XThemeVASubmitBTN
												size="medium"
												loading={
													clinicalSummaryTextLoading
												}
												type="primary"
												htmlType="submit"
											>
												Submit
											</XThemeVASubmitBTN>
										</Col>
									</Form>
								)}
							</Col>
						</Row>
					</XThemeVSSumInnerCard>
				),
			},
			{
				key: '1.5',
				label: 'Supporting Documents',
				children: (
					<XThemeVSSumInnerCard>
						<Row gutter={[15, 15]}>
							<Col xs={24}>
								{documentsToDisplay.length > 0 ? (
									<Row
										gutter={[15, 15]}
										className="align-items-center mb-3"
									>
										{documentsToDisplay.map(
											(doc, index) => (
												<Col
													xs={24}
													sm={12}
													xl={8}
													key={index}
												>
													<Tooltip
														title={
															doc.document_name ||
															doc.url?.name
														}
														placement="top"
													>
														<Space
															className="uploadDocs"
															onClick={() =>
																handlePreview(
																	doc.url,
																)
															}
															style={{
																border: '1px solid #e8e8e8',
																padding:
																	'8px 12px',
																borderRadius:
																	'4px',
																cursor: 'pointer',
																display: 'flex',
																alignItems:
																	'center',
																marginBottom:
																	'10px',
															}}
														>
															<img
																src="/images/pdf.svg"
																alt={
																	doc.document_name ||
																	doc.url
																		?.name
																}
															/>
															<div
																style={{
																	marginLeft:
																		'8px',
																	overflow:
																		'hidden',
																	textOverflow:
																		'ellipsis',
																	whiteSpace:
																		'nowrap',
																	maxWidth:
																		'200px',
																}}
															>
																{doc.document_name ||
																	doc.url
																		?.name}
															</div>
														</Space>
													</Tooltip>
												</Col>
											),
										)}
									</Row>
								) : (
									<div className="para1 mb-3">
										No supporting documents available
									</div>
								)}
							</Col>
						</Row>
					</XThemeVSSumInnerCard>
				),
			},
			{
				key: '1.6',
				label: 'Summary From Uploaded Documents',
				children: (
					<XThemeVSSumInnerCard>
						<Row gutter={[15, 15]}>
							<Col xs={24}>
								<div className="para text-justify">
									{patientData?.summary_docs ||
									supportingDocsSummary ? (
										<>
											{documentsToDisplay?.length > 0 &&
												documentsToDisplay.map(
													(doc, index) =>
														doc.info && (
															<div
																key={index}
																style={{
																	marginBottom:
																		'16px',
																}}
															>
																<div
																	style={{
																		fontWeight:
																			'bold',
																	}}
																>
																	{doc.document_name
																		? `Document Name: ${doc.document_name}`
																		: ''}
																</div>
																<div
																	className={`content-wrapper ${
																		expandedStates[
																			index
																		]
																			? 'expanded'
																			: ''
																	}`}
																	style={{
																		maxHeight:
																			expandedStates[
																				index
																			]
																				? 'none'
																				: '200px',
																		overflow:
																			'hidden',
																		position:
																			'relative',
																	}}
																>
																	<div
																		ref={(
																			el,
																		) =>
																			(contentRefs.current[
																				index
																			] =
																				el)
																		}
																		dangerouslySetInnerHTML={{
																			__html: doc.info,
																		}}
																	/>
																	{!expandedStates[
																		index
																	] &&
																		contentRefs
																			.current[
																			index
																		]
																			?.scrollHeight >
																			200 && (
																			<div
																				style={{
																					position:
																						'absolute',
																					bottom: 0,
																					left: 0,
																					right: 0,
																					height: '50px',
																				}}
																			/>
																		)}
																</div>
																{contentRefs
																	.current[
																	index
																]
																	?.scrollHeight >
																	200 && (
																	<div
																		onClick={() => {
																			const newExpandedStates =
																				[
																					...expandedStates,
																				];
																			newExpandedStates[
																				index
																			] =
																				!newExpandedStates[
																					index
																				];
																			setExpandedStates(
																				newExpandedStates,
																			);
																		}}
																		style={{
																			color: '#007299',
																			cursor: 'pointer',
																			marginTop:
																				'15px',
																			float: 'right',
																		}}
																	>
																		{expandedStates[
																			index
																		]
																			? 'Read Less'
																			: 'Read More'}
																	</div>
																)}
															</div>
														),
												)}

											{(!documentsToDisplay?.length ||
												!documentsToDisplay.some(
													(doc) => doc.info,
												)) && (
												<>
													<div
														className={`content-wrapper ${
															mainExpanded
																? 'expanded'
																: ''
														}`}
														style={{
															maxHeight:
																mainExpanded
																	? 'none'
																	: '200px',
															overflow: 'hidden',
															position:
																'relative',
														}}
													>
														<div
															ref={mainContentRef}
															dangerouslySetInnerHTML={{
																__html: isOpenAnalysis
																	? supportingDocsSummary
																	: currentRevision?.field ===
																	  'summary_docs'
																	? currentRevision?.finalValue
																	: patientData.summary_docs,
															}}
														/>
														{!mainExpanded &&
															mainContentRef
																.current
																?.scrollHeight >
																200 && (
																<div
																	style={{
																		position:
																			'absolute',
																		bottom: 0,
																		left: 0,
																		right: 0,
																		height: '50px',
																	}}
																/>
															)}
													</div>
													{mainContentRef.current
														?.scrollHeight >
														200 && (
														<div
															onClick={() =>
																setMainExpanded(
																	!mainExpanded,
																)
															}
															style={{
																color: '#007299',
																cursor: 'pointer',
																marginTop:
																	'15px',
																float: 'right',
															}}
														>
															{mainExpanded
																? 'Read Less'
																: 'Read More'}
														</div>
													)}
												</>
											)}
										</>
									) : (
										<div
											dangerouslySetInnerHTML={{
												__html:
													patientData?.summary_docs ||
													'No summary available for the supporting documents.',
											}}
										/>
									)}
								</div>
							</Col>
						</Row>
					</XThemeVSSumInnerCard>
				),
			},
			{
				key: '2',
				label: 'Past Clinical History',
				children: (
					<>
						<XThemeVSSumInnerCard>
							<Row className="mb-3">
								<Col xs={24} className="text-end">
									<Space>
										<XThemeVASubmitBTN
											size="medium"
											className="radiusBtn"
											shape="square"
											icon={<PlusSquareOutlined />}
											onClick={() => {
												form.setFieldsValue({
													modal_text_area: '',
												});
												setModalTextArea('');
												setModalOpen([
													true,
													'Add Past Clinical History',
													'',
													null,
													'pastHistory',
												]);
											}}
										/>
									</Space>
								</Col>
							</Row>

							{pageContent?.pastHistory &&
							pageContent.pastHistory.length > 0 ? (
								pageContent.pastHistory.map((row, index) => {
									const splitPastHistory =
										row.split('- ICD-10 Code:');

									return (
										<XThemeVSSumListCard
											className="mb-3"
											key={index}
										>
											<Row
												gutter={[15, 15]}
												className="align-items-center"
											>
												<Col xs={24} lg={14}>
													<div className="para1">
														{splitPastHistory.length >
														1
															? splitPastHistory[0]
															: row}
													</div>
												</Col>
												{splitPastHistory.length >
													1 && (
													<Col
														xs={24}
														lg={6}
														className="text-center"
														role="button"
														style={{
															borderLeft:
																'1px solid #57636F26',
															borderRight:
																'1px solid #57636F26',
														}}
													>
														<div className="para2">
															ICD-10:
															{
																splitPastHistory[1]
															}
														</div>
													</Col>
												)}
												<Col
													xs={24}
													lg={4}
													className="text-center"
												>
													<Space>
														<XThemeVASubmitBTN
															size="medium"
															className="radiusBtn me-2"
															shape="square"
															icon={
																<img
																	src="/images/edit-icon.svg"
																	alt=""
																/>
															}
															onClick={() => {
																handleModalEdit(
																	row,
																	index,
																	'pastHistory',
																);
															}}
														/>
														<XThemeVASubmitBTN
															size="medium"
															className="radiusBtn"
															shape="square"
															icon={
																<DeleteOutlined />
															}
															onClick={() =>
																showDeleteConfirm(
																	'Past Clinical History',
																	index,
																	row,
																	'pastHistory',
																)
															}
														/>
													</Space>
												</Col>
											</Row>
										</XThemeVSSumListCard>
									);
								})
							) : (
								<div className="para1">
									No past clinical history available
								</div>
							)}
						</XThemeVSSumInnerCard>
					</>
				),
			},
			{
				key: '3',
				label: 'Present Complaint',
				children: (
					<>
						<XThemeVSSumInnerCard>
							<Row className="mb-3">
								<Col xs={24} className="text-end">
									<Space>
										<XThemeVASubmitBTN
											size="medium"
											className="radiusBtn"
											shape="square"
											icon={<PlusSquareOutlined />}
											onClick={() => {
												form.setFieldsValue({
													modal_text_area: '',
												});
												setModalTextArea('');
												setModalOpen([
													true,
													'Add Present Complaint',
													'',
													null,
													'presentComplaint',
												]);
											}}
										/>
									</Space>
								</Col>
							</Row>

							{pageContent?.presentComplaint &&
							pageContent.presentComplaint.length > 0 ? (
								pageContent.presentComplaint.map(
									(row, index) => {
										const splitPresentComplaint =
											row.split('- ICD-10 Code:');

										return (
											<XThemeVSSumListCard
												className="mb-3"
												key={index}
											>
												<Row
													gutter={[15, 15]}
													className="align-items-center"
												>
													<Col xs={24} lg={14}>
														<div className="para1">
															{splitPresentComplaint.length >
															1
																? splitPresentComplaint[0]
																: row}
														</div>
													</Col>
													{splitPresentComplaint.length >
														1 && (
														<Col
															xs={24}
															lg={6}
															className="text-center"
															role="button"
															style={{
																borderLeft:
																	'1px solid #57636F26',
																borderRight:
																	'1px solid #57636F26',
															}}
														>
															<div className="para2">
																ICD-10:
																{
																	splitPresentComplaint[1]
																}
															</div>
														</Col>
													)}
													<Col
														xs={24}
														lg={4}
														className="text-center"
													>
														<Space>
															<XThemeVASubmitBTN
																size="medium"
																className="radiusBtn me-2"
																shape="square"
																icon={
																	<img
																		src="/images/edit-icon.svg"
																		alt=""
																	/>
																}
																onClick={() => {
																	handleModalEdit(
																		row,
																		index,
																		'presentComplaint',
																	);
																}}
															/>
															<XThemeVASubmitBTN
																size="medium"
																className="radiusBtn"
																shape="square"
																icon={
																	<DeleteOutlined />
																}
																onClick={() =>
																	showDeleteConfirm(
																		'Present Complaint',
																		index,
																		row,
																		'presentComplaint',
																	)
																}
															/>
														</Space>
													</Col>
												</Row>
											</XThemeVSSumListCard>
										);
									},
								)
							) : (
								<div className="para1">
									No present complaints available
								</div>
							)}
						</XThemeVSSumInnerCard>
					</>
				),
			},
			{
				key: '4',
				label: 'Denial Procedure',
				children: (
					<>
						<XThemeVSSumInnerCard>
							<Row className="mb-3">
								<Col xs={24} className="text-end">
									<Space>
										<XThemeVASubmitBTN
											size="medium"
											className="radiusBtn"
											shape="square"
											icon={<PlusSquareOutlined />}
											onClick={() => {
												form.setFieldsValue({
													modal_text_area: '',
												});
												setModalTextArea('');
												setModalOpen([
													true,
													'Add Denial Procedure',
													'',
													null,
													'recommendedProcedure',
												]);
											}}
										/>
									</Space>
								</Col>
							</Row>

							{pageContent?.recommendedProcedure &&
							pageContent.recommendedProcedure.length > 0 ? (
								pageContent.recommendedProcedure.map(
									(row, index) => {
										const splitRecommendedProcedure =
											row.split('- CPT Code:');

										return (
											<XThemeVSSumListCard
												className="mb-3"
												key={index}
											>
												<Row
													gutter={[15, 15]}
													className="align-items-center"
												>
													<Col xs={24} lg={14}>
														<div className="para1">
															{splitRecommendedProcedure.length >
															1
																? splitRecommendedProcedure[0]
																: row}
														</div>
													</Col>
													{splitRecommendedProcedure.length >
														1 && (
														<Col
															xs={24}
															lg={6}
															className="text-center"
															role="button"
															style={{
																borderLeft:
																	'1px solid #57636F26',
																borderRight:
																	'1px solid #57636F26',
															}}
														>
															<div className="para2">
																CPT:
																{
																	splitRecommendedProcedure[1]
																}
															</div>
														</Col>
													)}
													<Col
														xs={24}
														lg={4}
														className="text-center"
													>
														<Space>
															<XThemeVASubmitBTN
																size="medium"
																className="radiusBtn me-2"
																shape="square"
																icon={
																	<img
																		src="/images/edit-icon.svg"
																		alt=""
																	/>
																}
																onClick={() => {
																	handleModalEdit(
																		row,
																		index,
																		'recommendedProcedure',
																	);
																}}
															/>
															<XThemeVASubmitBTN
																size="medium"
																className="radiusBtn"
																shape="square"
																icon={
																	<DeleteOutlined />
																}
																onClick={() =>
																	showDeleteConfirm(
																		'Denial Procedure',
																		index,
																		row,
																		'recommendedProcedure',
																	)
																}
															/>
														</Space>
													</Col>
												</Row>
											</XThemeVSSumListCard>
										);
									},
								)
							) : (
								<div className="para1">
									No denial procedures available
								</div>
							)}
						</XThemeVSSumInnerCard>
					</>
				),
			},
			{
				key: '5',
				label: 'Medicare Coverage',
				children: (
					<>
						<XThemeVSSumListCard>
							<Row
								gutter={[15, 15]}
								className="align-items-center"
							>
								<Col xs={24}>
									<div className="para1">
										{pageContent?.medicalCoverage &&
										pageContent.medicalCoverage.length > 0
											? pageContent.medicalCoverage[1]
											: 'No Medicare coverage information available'}
									</div>
									{pageContent?.medicalCoverage &&
										pageContent.medicalCoverage[2] &&
										Object.keys(
											pageContent.medicalCoverage[2],
										).length > 0 && (
											<div className="para1 fst-italic">
												Reference:{' '}
												<Link
													to={
														pageContent
															.medicalCoverage[2][
															'target'
														]
													}
													target="_blank"
													className="text-decoration-underline"
												>
													{
														pageContent
															.medicalCoverage[2][
															'display_text'
														]
													}
												</Link>
											</div>
										)}
								</Col>
							</Row>
						</XThemeVSSumListCard>
					</>
				),
			},
		];
	};

	// Add Missing Inclusion Criteria if it exists
	const getCollapsedItems = () => {
		const items = getCollapseItems();

		if (
			pageContent?.missing_points_for_coverage &&
			pageContent.missing_points_for_coverage.length > 0
		) {
			items.push({
				key: '6',
				label: (
					<div style={{ display: 'flex', alignItems: 'center' }}>
						Missing Inclusion Criteria
						<Tooltip title="This feature is experimental and may contain errors as it evolves. Please exercise discretion, especially when reviewing critical information.">
							<Tag
								style={{
									marginLeft: '8px',
									border: '1px solid #9B68BF',
									color: '#9B68BF',
									fontSize: '11px',
								}}
							>
								Alpha
							</Tag>
						</Tooltip>
					</div>
				),
				children: (
					<XThemeVSSumListCard>
						<Row gutter={[15, 15]} className="align-items-center">
							<Col xs={24}>
								<ul
									className="listCircule"
									style={{ paddingLeft: '20px', margin: '0' }}
								>
									{pageContent.missing_points_for_coverage.map(
										(point, index) => (
											<li key={index}>{point}</li>
										),
									)}
								</ul>
							</Col>
						</Row>
					</XThemeVSSumListCard>
				),
			});
		}

		return items;
	};

	// 4. Fix date formatting - create a proper date formatter
	const formatDate = (dateString) => {
		if (!dateString) return '-';
		const date = dayjs(dateString);
		return date.isValid() ? date.format('MM-DD-YYYY') : '-';
	};

	return (
		<>
			<XContainer fluid>
				<div className="marginTopMobile "></div>
				<XAffix
					id="notification"
					className="d-none zIndex"
					offsetTop={10}
				>
					<div className="marginBottomMobile"></div>
					<div
						className="mb-3"
						style={{
							backgroundColor: 'white',
							borderRadius: '20px',
							zIndex: '1111110',
						}}
					>
						<XNotificationBar style={{ zIndex: '22222' }}>
							Clinical Summary has been changed !! Click to{' '}
							<XButtonReload
								type="button"
								style={{ padding: '18px' }}
								className="refreshBtn"
								onClick={() => {
									setLoading(true);
									document
										.getElementById('notification')
										?.classList.add('d-none');

									reviseCoverageReset();
									// Update lastAnalysisData with the latest pageContent values
									const updatedLastAnalysisData = {
										...lastAnalysisData, // Keep all the existing keys and values intact
										'Past History': pageContent.pastHistory, // Update pastHistory
										'Present Complaint':
											pageContent.presentComplaint, // Update presentComplaint
										'Suggested Treatment':
											pageContent.recommendedProcedure, // Update recommendedProcedure
										'Medicare Evaluation': {
											...lastAnalysisData[
												'Medicare Evaluation'
											],
											Coverage:
												pageContent.medicalCoverage[0], // Update medicalCoverage fields
											Rationale:
												pageContent.medicalCoverage[1],
											reference:
												pageContent.medicalCoverage[2],
										},
										original_query:
											pageContent.originalQuery, // Update original_query
										past_history: pageContent.pastHistory, // Update past_history in lastAnalysisData
										present_complaint:
											pageContent.presentComplaint, // Update present_complaint in lastAnalysisData
										status: pageContent.status, // Update status in lastAnalysisData
										missing_points_for_coverage:
											pageContent.missing_points_for_coverage, // Update missing_points_for_coverage
										// Add other updates if necessary, or keep them unchanged
									};
									reviseCoverage({
										case_id: patientData._id,
										feedbackId: feedbackId,
										clinicalHistory:
											pageContent.pastHistory,
										presentComplaint:
											pageContent.presentComplaint,
										recommendedProcedure:
											pageContent.recommendedProcedure,
										medicalCoverage:
											pageContent.medicalCoverage,
										state: patientData.state,
										provider:
											patientData.insurance_company?.name,
										last_analysis_data:
											updatedLastAnalysisData,
										supportingDocsSummary:
											patientData &&
											patientData.summary_docs,
										revenue_cycle:
											patientData.revenue_cycle,
									});
								}}
							>
								Reanalyse it !!
							</XButtonReload>
							<XButtonCloseBar
								type="button"
								className="closeBar mt-3"
							>
								<CloseOutlined
									onClick={() => {
										document
											.getElementById('notification')
											?.classList.add('d-none');
									}}
									style={{ fontSize: '20px' }}
								/>
							</XButtonCloseBar>
						</XNotificationBar>
					</div>
					<div className="marginNone"></div>
				</XAffix>
			</XContainer>
			<XThemeVSSetViewPort>
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="mb-3">
							<Row gutter={[15, 15]} align="middle">
								{openedFromTable && (
									<Col xs={2} sm={2} lg={2}>
										<XThemeVASubmitBTN
											type="button"
											size="large"
											icon={<ArrowLeftOutlined />}
											onClick={handleBackToTable}
											style={{
												backgroundColor: '#f0f0f0',
												border: '1px solid #d9d9d9',
												color: '#666',
												borderRadius: '25px',
												padding: '8px 16px',
												height: 'auto',
											}}
										>
											Back to Listing
										</XThemeVASubmitBTN>
									</Col>
								)}
								{!openedFromTable && (
									<Col xs={24} sm={24} lg={24}>
										<XThemeVoiceAssTitle>
											{/* Hey Amin,
											<br /> */}
											<span>Case Details</span>
										</XThemeVoiceAssTitle>
									</Col>
								)}
							</Row>
						</Col>
						<Col xs={24}>
							<XThemeVoiceAssTableCard>
								<XThemeVoiceAssTableCard
									className={
										isCollapsedScroll ? '' : 'fixedHeight'
									}
								>
									<div className="hasPadding">
										<XThemeVSDetailsCard
											className={
												isExpanded ? '' : 'isExpanded'
											}
										>
											<Row
												gutter={[15, 15]}
												className="align-items-center"
											>
												<Col xs={2} sm={2} lg={2}>
													<div className="tagsView">
														2<sup>nd</sup>
													</div>
												</Col>
												<Col xs={20} sm={20} lg={20}>
													<Row gutter={[15, 15]}>
														<Col
															xs={24}
															sm={12}
															lg={16}
														>
															<div className="titleHead1">
																{patientData?.patient_name ||
																	'Patient Name'}
																<span className="me-4">
																	{patientData?.mrn ||
																		'MRN'}
																</span>
																<XThemeTag
																	style={{
																		background:
																			'#ED982A33',
																		color: '#ED982A',
																	}}
																>
																	{toTitleCase(
																		patientData?.status ||
																			'Status',
																	)}
																</XThemeTag>
															</div>
															<div className="titleHead2">
																{patientData?.case_id ||
																	'Case ID'}
															</div>
														</Col>
													</Row>
												</Col>
												<Col
													xs={2}
													sm={2}
													lg={2}
													className="text-end"
												>
													<XThemeHeaderBTN
														onClick={() =>
															setIsExpanded(
																!isExpanded,
															)
														}
														shape="circle"
														size="large"
														icon={
															isExpanded ? (
																<img
																	className="img-fluid"
																	src="/images/va-expended-icon.svg"
																	alt="Expended"
																/>
															) : (
																<img
																	className="img-fluid"
																	src="/images/vs-expend-icon.svg"
																	alt="Expend"
																/>
															)
														}
													/>
												</Col>
											</Row>

											<Row
												gutter={[15, 10]}
												className="align-items-center mt-3"
											>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>Insurance</span>
														<br />
														{patientData
															?.insurance_company
															?.name || '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>Hospital</span>
														<br />
														{patientData?.hospital
															?.name || '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>State</span>
														<br />
														{patientData?.state ||
															'-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>DOB</span>
														<br />
														{dateOfBirth(
															patientData?.date_of_birth,
														)}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>Gender</span>
														<br />
														{toTitleCase(
															patientData?.gender ||
																'-',
														)}
														{matchGender ===
															false && (
															<Tooltip
																title="The gender of the patient does not correspond with the gender entered in the Clinical Summary."
																trigger={
																	'hover'
																}
															>
																<WarningOutlined
																	style={{
																		color: 'red',
																		marginLeft:
																			'5px',
																	}}
																/>
															</Tooltip>
														)}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Organization
														</span>
														<br />
														{patientData
															?.organization
															?.name || '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Revenue Cycle
														</span>
														<br />
														{patientData?.revenue_cycle ===
															'pre_service' &&
															'Pre Service'}
														{patientData?.revenue_cycle ===
															'post_claim' &&
															'Post Claim'}
														{patientData?.revenue_cycle ===
															'part_b_drugs' &&
															'Part B Drugs'}
														{patientData?.revenue_cycle ===
															'pre_service_part_c' &&
															'Pre Service Part C'}
														{patientData?.revenue_cycle ===
															'post_claim_part_c' &&
															'Post Claim Part C'}
														{!patientData?.revenue_cycle &&
															'-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Revenue Cycle Stage
														</span>
														<br />
														{patientData?.revenue_cycle_stage ===
															'organization_determination' &&
															'Organization Determination'}
														{patientData?.revenue_cycle_stage ===
															'first_appeal' &&
															'First Appeal'}
														{patientData?.revenue_cycle_stage ===
															'second_appeal' &&
															'Second Appeal'}
														{patientData?.revenue_cycle_stage ===
															'third_appeal' &&
															'Third Appeal'}
														{patientData?.revenue_cycle_stage ===
															'fourth_appeal' &&
															'Fourth Appeal'}
														{patientData?.revenue_cycle_stage ===
															'judicial_review' &&
															'Judicial Review'}
														{!patientData?.revenue_cycle_stage &&
															'-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Insurance Claim
															Number
														</span>
														<br />
														{patientData?.insurance_claim_number ||
															'-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Providers Encounter
															Number
														</span>
														<br />
														{patientData?.providers_encounter_number ||
															'-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>Region</span>
														<br />
														{patientData?.region
															?.name || '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Allocated to
														</span>
														<br />
														{patientData
															?.allocated_to
															?.name || '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Claim Amount
														</span>
														<br />
														{patientData?.claim_amount
															? `$${patientData.claim_amount}`
															: '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>Case Amount</span>
														<br />
														{patientData?.case_amount
															? `$${patientData.case_amount}`
															: '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Discharge Date
														</span>
														<br />
														{patientData?.date_of_discharge
															? formatDate(
																	patientData.date_of_discharge,
															  )
															: '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Hearing Date
														</span>
														<br />
														{patientData?.hearing_date
															? dayjs(
																	patientData.hearing_date,
															  ).format(
																	'MM-DD-YYYY',
															  )
															: '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Admission Date
														</span>
														<br />
														{patientData?.date_of_admission
															? formatDate(
																	patientData.date_of_admission,
															  )
															: '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>EOB Date</span>
														<br />
														{patientData?.date_of_eob
															? formatDate(
																	patientData.date_of_eob,
															  )
															: '-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Process Type
														</span>
														<br />
														{patientData?.process_type ===
															'ma_standard' &&
															'MA Standard Appeal Turn-Around-Time (TAT)'}
														{patientData?.process_type ===
															'ma_expedited' &&
															'MA Expedited Appeal Turn-Around-Time (TAT)'}
														{!patientData?.process_type &&
															'-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>Visit Type</span>
														<br />
														{patientData?.visit_type ||
															'-'}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>Status</span>
														<br />
														{capitalizeFirstLetter(
															patientData?.status,
														)}
													</div>
												</Col>
												<Col xs={12} sm={12} lg={8}>
													<div className="para1">
														<span>
															Date of Service
														</span>
														<br />
														{patientData
															?.date_of_service
															?.single_date
															?.length > 0 ? (
															<>
																{patientData.date_of_service.single_date.map(
																	(
																		date,
																		index,
																	) => (
																		<span
																			key={
																				index
																			}
																		>
																			{dayjs(
																				date,
																			).format(
																				'MM-DD-YYYY',
																			)}
																			{index <
																				patientData
																					.date_of_service
																					.single_date
																					.length -
																					1 && (
																				<span>
																					,&nbsp;
																				</span>
																			)}
																		</span>
																	),
																)}
															</>
														) : patientData
																?.date_of_service
																?.date_range
																?.length > 0 ? (
															<>
																{patientData.date_of_service.date_range.map(
																	(
																		range,
																		index,
																	) => (
																		<span
																			key={
																				index
																			}
																		>
																			{range[0]
																				? dayjs(
																						range[0],
																				  ).format(
																						'MM-DD-YYYY',
																				  )
																				: ''}{' '}
																			to{' '}
																			{range[1]
																				? dayjs(
																						range[1],
																				  ).format(
																						'MM-DD-YYYY',
																				  )
																				: ''}
																			{index <
																				patientData
																					.date_of_service
																					.date_range
																					.length -
																					1 && (
																				<span>
																					,&nbsp;
																				</span>
																			)}
																		</span>
																	),
																)}
															</>
														) : (
															formatDate(
																patientData?.date_of_service,
															)
														)}
													</div>
												</Col>
											</Row>
										</XThemeVSDetailsCard>
										<Row>
											<Col xs={24}>
												<XThemeVSCollapse
													bordered={false}
													expandIcon={({
														isActive,
													}) => (
														<span
															style={{
																transform: `rotate(${
																	isActive
																		? 90
																		: 270
																}deg)`,
																transition:
																	'transform 0.3s ease',
															}}
														>
															<img
																class="img-fluid"
																src="/images/chat-back-icon.svg"
																alt=""
															/>
														</span>
													)}
													expandIconPosition="end"
													accordion
													activeKey={
														activeCollapseKey
													}
													onChange={(key) => {
														setActiveCollapseKey(
															key,
														);
														setContentRendered(
															false,
														);
													}}
													items={getCollapsedItems()}
												/>
											</Col>
										</Row>
									</div>
								</XThemeVoiceAssTableCard>
								<XThemeVSDetailsFooter>
									<Row gutter={[15, 15]}>
										<Col
											xs={24}
											sm={12}
											lg={12}
											className="text-start"
										>
											<Space>
												<XThemeVASubmitBTN
													size="large"
													className="noBackground"
													icon={
														<img
															class="rotateButton"
															src="/images/like-icon.svg"
															alt=""
														/>
													}
													onClick={() => {
														// Open modal for feedbackSummary
														form.setFieldsValue({
															medicare_flag:
																pageContent
																	.medicalCoverage?.[0] ||
																'',
															modal_text_area:
																pageContent
																	.medicalCoverage?.[1] ||
																'',
														});
														setModalTextArea(
															pageContent
																.medicalCoverage?.[1] ||
																'',
														);
														setModalOpen([
															true,
															`Edit Medicare Coverage`,
															pageContent
																.medicalCoverage?.[1] ||
																'',
															1,
															'feedbackSummary',
														]);
													}}
												>
													Refine
												</XThemeVASubmitBTN>
												<XThemeVASubmitBTN
													size="large"
													className="noBackground"
													icon={
														<img
															src="/images/like-icon.svg"
															alt=""
														/>
													}
													onClick={() => {
														props.setLooksGoodLoading(
															true,
														);
														props.onSendFeedback(
															'positive',
															'approved',
															props.pageContent
																.medicalCoverage,
														);
													}}
													loading={
														props.LooksGoodLoading
													}
												>
													Looks Good
												</XThemeVASubmitBTN>
											</Space>
										</Col>
										<Col
											xs={24}
											sm={12}
											lg={12}
											className="text-sm-end"
										>
											<XThemeVASubmitBTN
												size="large"
												onClick={() => {
													props.onSendFeedback(
														null,
														'approved',
														props.pageContent
															.medicalCoverage,
													);
												}}
												loading={props.coverageloading}
												disabled={
													props.pageContent
														?.status === 'approved'
												}
											>
												Confirm Coverage
											</XThemeVASubmitBTN>
										</Col>
									</Row>
								</XThemeVSDetailsFooter>
							</XThemeVoiceAssTableCard>
							{/* <div className="w-100 text-center">
								<XThemeVAViewHiddenBTN
									type="primary"
									icon={
										<img
											src="/images/chat-back-icon.svg"
											alt=""
											className={
												isCollapsedScroll
													? 'iconRotateDefault'
													: 'iconRotate'
											}
										/>
									}
									iconPosition="end"
									onClick={() =>
										setIsCollapsedScroll(!isCollapsedScroll)
									}
								>
									View Case Details
								</XThemeVAViewHiddenBTN>
							</div> */}
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>

			<XThemeModal
				open={previewOpen}
				title={previewTitle}
				footer={null}
				onCancel={() => setPreviewOpen(false)}
			>
				{previewImage ? (
					<img
						alt="example"
						style={{
							width: '100%',
						}}
						src={previewImage}
					/>
				) : null}
			</XThemeModal>

			{/* Clinical Summary Upload */}
			<Modal
				// title="Upload Clinical Document"
				title={
					<>
						<span className="modalTitleIcon">
							<img
								src="/images/upload-modal-icon.svg"
								alt="Upload"
							/>
						</span>
						Upload Clinical Document
					</>
				}
				open={isClinicalUploadModalOpen}
				onOk={handleClinicalDocsUpload}
				okButtonProps={{
					loading: clinicalDocsLoading,
					className: 'xThemeButtonSubmit',
				}}
				cancelButtonProps={{
					className: 'xThemeCancelSubmit',
				}}
				onCancel={() => {
					if (!clinicalDocsLoading) {
						clinicalDocsForm.resetFields();
						handleUploadCancel();
					}
				}}
			>
				<XThemeForm
					form={clinicalDocsForm}
					layout="vertical"
					autoComplete="off"
				>
					<XThemeForm.Item
						name="clinical_docs"
						className="mt-4"
						rules={[
							{
								required: true,
								validator: (_, value) => {
									if (clinicalDocumentFileList.length === 0) {
										return Promise.reject(
											new Error('Please Select file!'),
										);
									}
									return Promise.resolve();
								},
							},
						]}
					>
						<Dragger
							fileList={clinicalDocumentFileList}
							maxCount={1}
							beforeUpload={(file) => {
								const isJPEG = file.type === 'image/jpeg';
								const isJPG = file.type === 'image/jpg';
								const isPNG = file.type === 'image/png';
								const isGIF = file.type === 'image/gif';
								const isVideo = file.type.startsWith('video/');
								const isAudio = file.type.startsWith('audio/');

								const isLt10M = file.size / 1024 / 1024 < 10;

								if (!isLt10M) {
									notification.error({
										message: 'File Size Exceeded',
										description: `The file ${file.name} exceeds the maximum allowed size of 10MB.`,
									});
								}
								if (
									isGIF ||
									isVideo ||
									isAudio ||
									isJPEG ||
									isJPG ||
									isPNG
								) {
									notification.error({
										message: 'File Type Error',
										description: `GIF, video, image and audio files are not allowed.`,
									});
								}

								return (
									isLt10M &&
									!isGIF &&
									!isVideo &&
									!isAudio &&
									!isJPEG &&
									!isJPG &&
									!isPNG
								);
							}}
							// accept=".pdf,.jpeg,.jpg,.png"
							accept=".pdf"
							onChange={handleClinicalDocsChange}
						>
							<p className="ant-upload-drag-icon">
								<InboxOutlined style={{ color: '#007299' }} />
							</p>
							<p className="ant-upload-text">
								Click or drag file to this area to upload
							</p>
						</Dragger>
					</XThemeForm.Item>
				</XThemeForm>
			</Modal>

			{/* Modal for uplodoaded Files preview */}
			<XThemeModal
				open={pdfPreviewOpen}
				title="Preview"
				footer={null}
				onCancel={() => setPdfPreviewOpen(false)}
				width={700} // Set the width of the modal dynamically
				// Other modal props...
			>
				<div>
					<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
						<div style={{ height: '750px' }}>
							<Viewer fileUrl={previewImage} />
						</div>
					</Worker>
				</div>
			</XThemeModal>

			<XThemeModal
				title={
					<>
						<span className="modalTitleIcon">
							{modalOpen[4] !== 'feedbackSummary' &&
							modalOpen[2] === '' ? (
								<img
									className="img-fluid"
									src="/images/add-modal-icon.svg"
									alt=""
								/>
							) : (
								<img
									className="img-fluid"
									src="/images/edit-modal-icon.svg"
									alt=""
								/>
							)}
						</span>
						{modalOpen[1]}
					</>
				}
				centered
				open={modalOpen[0]}
				onOk={() => {
					form.validateFields()
						.then((res) => {
							if (modalOpen[4] === 'feedbackSummary') {
								sendFeedback({
									feedback_id: feedbackId,
									feedback: 'negative',
									status: 'pending_for_analysis',
									response: [coverage, modalTextArea],
								});
							} else {
								// Format the text according to the selected code type (ICD-10 or CPT)
								const formattedText = `${
									res.modal_text_area
								} - ${
									modalOpen[4] === 'recommendedProcedure'
										? 'CPT Code'
										: 'ICD-10 Code'
								}: ${res.code}`;
								// Save the formatted text in setModalTextArea
								setModalTextArea(formattedText);

								// Optionally update page content
								updatePageContent(
									modalOpen[4],
									modalOpen[3],
									formattedText,
								);
							}
						})
						.catch((err) => {
							console.log('error', err);
						});
				}}
				okButtonProps={{
					className: 'xThemeButtonSubmit',
					loading: sendFeedbackState.apiState === 'loading',
					// style: {
					// 	backgroundColor: '#007299', // Custom background color
					// 	color: '#fff', // Text color
					// },
				}}
				cancelButtonProps={{
					className: 'xThemeCancelSubmit',
					// Add an icon to the Cancel button
					// style: {
					// 	backgroundColor: '#fff', // Red background for Cancel
					// 	color: '#007299', // Text color
					// },
				}}
				onCancel={() => {
					form.resetFields();
					setModalTextArea('');
					setModalOpen([false, '', ' ']);
				}}
				okText="Submit"
				width={800}
			>
				<XThemeForm
					form={form}
					name="groupForm"
					layout="vertical"
					autoComplete="off"
				>
					<Row gutter={(15, 15)} className="mt-4">
						<Col xs={24}>
							{modalOpen[4] === 'feedbackSummary' && (
								<>
									<XThemeForm.Item
										className="drawerlabel"
										name="medicare_flag"
										label="Coverage"
										rules={[
											{
												required: true,
												message: 'Field is required',
											},
										]}
									>
										<XThemeSelect
											className="largeInputForms"
											size="large"
											showSearch
											placeholder="Select a person"
											optionFilterProp="children"
											onChange={(e) => {
												setCoverage(e);
											}}
											options={[
												{
													value: 'Yes',
													label: 'YES',
												},
												{
													value: 'No',
													label: 'NO',
												},
											]}
										/>
									</XThemeForm.Item>

									<XThemeForm.Item
										className="textAreaStyleDarkBorder drawerlabel"
										name="modal_text_area"
										rules={[
											{
												required: true,
												message: 'Field is required',
											},
										]}
									>
										<XThemeInputText.TextArea
											size="large"
											rows={6}
											name="modal_text_area"
											showCount
											style={{
												minHeight: 120,
												marginBottom: 24,
											}}
											// className="textArea mt-2"
											placeholder="Enter"
											onChange={(e) =>
												setModalTextArea(e.target.value)
											}
										>
											{/* modalOpen[2] */}
										</XThemeInputText.TextArea>
									</XThemeForm.Item>
								</>
							)}
							{modalOpen[4] !== 'feedbackSummary' && (
								<>
									<XThemeForm.Item
										className="textAreaStyleDarkBorder drawerlabel"
										name="modal_text_area"
										label="Description"
										rules={[
											{
												required: true,
												message:
													'Description is required',
											},
										]}
									>
										<XThemeInputText.TextArea
											size="large"
											name="modal_text_area"
											showCount
											// style={{
											// 	height: 100,
											// }}
											rows={6}
											placeholder="Enter description"
										/>
									</XThemeForm.Item>
									<XThemeForm.Item
										className="drawerlabel"
										name="code"
										label={`${
											modalOpen[4] ===
											'recommendedProcedure'
												? 'CPT'
												: 'ICD-10'
										} Code`}
										rules={[
											{
												required: true,
												message: 'Code is required',
											},
										]}
									>
										<XThemeInputText
											className="largeInputForms"
											placeholder={`Enter ${
												modalOpen[4] ===
												'recommendedProcedure'
													? 'CPT'
													: 'ICD-10'
											} Code`}
										/>
									</XThemeForm.Item>
								</>
							)}
						</Col>
					</Row>
				</XThemeForm>
			</XThemeModal>
		</>
	);
};

export default VACaseDetails;
